import {Toast} from "primereact/toast";
import {baseUrl} from "./webInfo";
import {deleteToken} from "@firebase/messaging";
import {RGB} from "../types/demo";
import {FormatCurrencyOptions, SortDirection} from "../types/helper";
import {format, isValid, parseISO} from "date-fns";



export default function callToast(
    toast: React.RefObject<Toast | null>,
    type: boolean | string,
    msg: string,
    life: number = 3000
) {
    if (toast?.current) {
        toast?.current?.show({
            severity: type === "warn" ? "warn" : type ? "success" : "error",
            summary: type === "warn" ? "Warning" : type ? "Successful" : "Error",
            detail: msg,
            life: life,
        });
    }
}

export const approvalStatus = [
    {
        id: 0, name: "Pending",
    },
    {
        id: 1, name: "Approved",
    },
    {
        id: 2, name: "Rejected"
    }
]

let timeout: any;
export const debounceFunction = (fn: Function, delay: number = 600) => {
    return (...arg: any) => {
        if (timeout) {
            clearTimeout(timeout)
        }
        timeout = setTimeout(() => {
            fn(...arg)
        }, delay)
    }
}

//Hide popup
export const hidePopup = (ref: { current: number }) => {
    ref.current = 0
}

// Custom delete function
// export const handleDelete = async (params: deleteParams) => {
//     const {
//         id, endPoint, name, data = [], setData, token,
//         toast, setUpdate
//     } = params
//     const filteredData = data.filter((data: any) => data?.id !== id);
//     try {
//         const res = await fetch(`${baseUrl?.url}${endPoint}`, {
//             method: "DELETE",
//             headers: {
//                 Authorization: `Bearer ${token}`,
//             },
//             body: JSON.stringify([{id: id}]),
//         });
//
//         if (res.ok) {
//             if (data?.length > 0 && setData) {
//                 setData(filteredData);
//             }
//
//             if (setUpdate) {
//                 setUpdate((previous: boolean) => !previous)
//             }
//
//             callToast(toast, true, `${name} deleted successfully`);
//         } else {
//             const responseData = await res.json();
//             callToast(toast, false, responseData?.errors[0]);
//         }
//     } catch (error: any) {
//         callToast(toast, false, error?.message);
//     }
// };


export const handleChangeData = (name: string, value: any, allData: {
    [key: string]: string | any
}, setAllData: any) => {
    return setAllData({
        ...allData,
        [name]: value
    })
}

export const getFileExtension = (filename: string) => {
    const parts = filename.split('.');
    return parts.length > 1 ? parts.pop() : '';
}

export const handleDataUpdate = (id: number, value: any, allData: any, setAllData: any, name: string,) => {
    const updatedData = allData?.map((data: any) => {
        if (data?.id === id) {
            return {
                ...data,
                [name]: value
            }
        }
        return data
    })
    setAllData(updatedData)
}

export const handleRemoveRow = (id: number, allData: any, setAllData: any) => {
    const updatedData = allData?.filter((data: any) => data?.id !== id)
    setAllData(updatedData)
}

export const tablePerPageOptions = [10, 20, 30, 50, 100]


// Get Date Difference Function
export const getDiffInDays = (dateRange: Date[]) => {
    // Convert both dates to milliseconds
    const start = new Date(dateRange[0]).getTime();
    const end = new Date(dateRange[1]).getTime();
    // Calculate the difference in milliseconds
    const diffInMs = end - start;
    // Convert milliseconds to days (1 day = 86400000 milliseconds)
    return diffInMs / (1000 * 60 * 60 * 24);
}

// Notification Unsubscription
export const handleNotificationUnSubscription = async (notificationToken: string, messaging: any, accessToken: string) => {
    try {
        const response = await fetch(`${baseUrl.url}/api/notification_unsubscription`, {
            method: 'Delete',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify({token: notificationToken})
        });
        if (response.ok) {
            localStorage.removeItem("notificationToken")
            if (notificationToken) {
                await deleteToken(messaging);
                console.log('Firebase Messaging token deleted successfully');
            } else {
                console.log('No Firebase Messaging token to delete');
            }
            localStorage.removeItem("notificationToken")
        }

    } catch (error) {
        console.error('Error getting token:', error);
    }

}

// Export Data
export const handleExportData = async (endPoint: string, type: string, token: string, toast: any, name = "",setExportLoading: Function, successFunction?: Function) => {
    try {
        setExportLoading(true)
        // const res = await fetch(
        //     `${baseUrl.url}${endPoint}`,
        //     {
        //         method: "GET",
        //         headers: {
        //             "Content-Type": "application/json",
        //             Authorization: `Bearer ${token}`,
        //         },
        //     }
        // );
        // const data = await res.blob();
        // if (res.status === 204) {
        //     return callToast(toast, false, "No Data Found")
        // }
    } catch (error: any) {
        callToast(toast, false, error?.message)
    } finally {
        setExportLoading(false)
    }
}

// Download File
export const downloadFileInDevice = async(url:string) => {
    // let url = `https://apibanglatel.selopian.us/assets/images/user/user-38e38cb5-0992-49e7-aa0c-cbaf3b3e3e91.jpg`
    // const url = "https://upload.wikimedia.org/wikipedia/commons/thumb/3/32/Googleplex_HQ_%28cropped%29.jpg/800px-Googleplex_HQ_%28cropped%29.jpg";
    try{
        const res = await  fetch(url)
        if(res.ok){
            const blob = await res.blob()
            const link = document.createElement("a");
            link.href = URL.createObjectURL(blob)
            link.download = `statement-${new Date().getTime()}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }else{
            window.open(url, "_self")
        }

    }
    catch(error){
        console.log(error)
    }
};

export const getDisplayFileName = (filePath: string) => {
    if (!filePath) return 'Upload Document';
    const parts = filePath.split('/');
    const folderName = parts[parts.length - 2];
    const extension = parts[parts.length - 1]?.split('.').pop(); // e.g., 'png'
    // const shortName = folderName.split('__')[0]
    return `${folderName}.${extension}`;
};


export const getFileExtensionType = (filename: string): string => {
    return filename.split('.').pop()?.toLowerCase() || '';
};


// File Checker
export const isImageFile = (filename: string): boolean => {
    const imageExts: string[] = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
    const ext: string = getFileExtensionType(filename);
    return imageExts.includes(ext);
};

// Post JSON Format
export const postJson = (data: any) => {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    }
}
// Post File Format
export const postFile = (File: any) => {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: File,
    }
}
// Catch Error
export const catchError = (error: any) => {
    console.log(error)
}



export const colorHexToRgb = (hex: string): RGB => {
    // Remove the hash if present
    hex = hex.replace(/^#/, '');

    // Handle shorthand hex (e.g., #fff)
    if (hex.length === 3) {
        hex = hex.split('').map(char => char + char).join('');
    }

    // Validate hex format
    if (!/^[0-9A-Fa-f]{6}$/.test(hex)) {
        throw new Error('Invalid hex color format');
    }

    // Parse hex values
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    return { r, g, b };
};

// Optional: Returns RGB string
export const colorHexToRgbString = (hex: string): string => {
    const { r, g, b } = colorHexToRgb(hex);
    return `rgb(${r}, ${g}, ${b})`;
};

export interface FileInfo {
    name: string;
    size: number;
    type: string;
    lastModified?: number;
}

/**
 * Converts a Base64 string to a File object
 * @param base64 - Base64 string (can include or exclude data URL prefix)
 * @param filename - Name for the resulting file
 * @param mimeType - MIME type of the file
 * @returns File object
 */
export const base64ToFile = (base64: string, filename: string, mimeType: string): File => {
    // Remove data URL prefix if present (e.g., "data:image/png;base64,")
    const base64Data = base64.includes('base64,')
        ? base64.split('base64,')[1]
        : base64;

    // Convert base64 to binary
    const byteCharacters = atob(base64Data);
    const byteArrays: Uint8Array[] = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    // Create and return File object
    const blob = new Blob(byteArrays, { type: mimeType });
    return new File([blob], filename, { type: mimeType });
};

/**
 * Extracts MIME type from a base64 string
 * @param base64String - Base64 string with or without data URL prefix
 * @returns MIME type or default 'application/octet-stream'
 */
export const getMimeTypeFromBase64 = (base64String: string): string => {
    const match = base64String.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);
    return match ? match[1] : 'application/octet-stream';
};

/**
 * Gets file extension from MIME type or filename
 * @param mimeType - MIME type of the file
 * @param filename - Optional filename to extract extension
 * @returns File extension (including dot)
 */
export const getFileExtension64 = (mimeType: string, filename?: string): string => {
    if (filename && filename.includes('.')) {
        return filename.substring(filename.lastIndexOf('.'));
    }

    const mimeToExt: Record<string, string> = {
        'image/jpeg': '.jpg',
        'image/jpg': '.jpg',
        'image/png': '.png',
        'image/gif': '.gif',
        'image/webp': '.webp',
        'image/svg+xml': '.svg',
        'application/pdf': '.pdf',
        'text/plain': '.txt',
        'application/json': '.json',
        'video/mp4': '.mp4',
        'audio/mpeg': '.mp3',
    };
    return mimeToExt[mimeType] || '.bin';
};


/**
 * Converts a File object to a Base64 string (includes data URL prefix)
 * @param file - File object to convert
 * @returns Promise resolving to complete data URL
 */
export const fileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = () => {
            if (typeof reader.result === 'string') {
                resolve(reader.result);
            } else {
                reject(new Error('Failed to convert file to base64: result is not a string'));
            }
        };

        reader.onerror = (error) => {
            reject(error);
        };

        reader.readAsDataURL(file);
    });
};


// Delay
export const sleep = (ms: number): Promise<void> => {
    return new Promise(resolve => {
        setTimeout(resolve, ms);
    });
};

/**
 * Clamps a value between a minimum and maximum range
 * @param value - The value to clamp
 * @param min - The minimum allowed value
 * @param max - The maximum allowed value
 * @returns The clamped value
 */
export const clamp = (value: number, min: number, max: number): number => {
    return Math.min(Math.max(value, min), max);
};

/**
 * Linearly interpolates between two values based on a progress parameter
 * @param a - The start value
 * @param b - The end value
 * @param t - The interpolation factor (usually between 0 and 1)
 * @returns The interpolated value
 */
export const lerp = (a: number, b: number, t: number): number => {
    return a + (b - a) * t;
};


//Validation Function
export const validateForm = (values: any, schema: any) => {
    const errors: any = {};
    for (const key in schema) {
        const error = schema[key](values[key]);
        if (error) {
            errors[key] = error;
        }
    }

    return errors;
};

//UUID generation function
export const generateId = (): string => {
    // Use native crypto if available (modern browsers)
    if (crypto?.randomUUID) {
        return crypto.randomUUID();
    }

    // Fallback for older browsers
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (char) => {
        const rand = (Math.random() * 16) | 0;
        const value = char === "x" ? rand : (rand & 0x3) | 0x8;
        return value.toString(16);
    });
};

//Deep Cloning
export const deepClone = <T>(obj: T): T => {
    // Primitives & functions
    if (obj === null || typeof obj !== "object") {
        return obj;
    }

    // Date
    if (obj instanceof Date) {
        return new Date(obj.getTime()) as T;
    }

    // Array
    if (Array.isArray(obj)) {
        return obj.map(item => deepClone(item)) as T;
    }

    // Map
    if (obj instanceof Map) {
        const clonedMap = new Map();
        obj.forEach((value, key) => {
            clonedMap.set(key, deepClone(value));
        });
        return clonedMap as T;
    }

    // Set
    if (obj instanceof Set) {
        const clonedSet = new Set();
        obj.forEach(value => {
            clonedSet.add(deepClone(value));
        });
        return clonedSet as T;
    }

    // Object
    const clonedObj: Record<string, any> = {};
    Object.keys(obj as object).forEach((key) => {
        clonedObj[key] = deepClone((obj as any)[key]);
    });

    return clonedObj as T;
};

// Format Currency
export const formatCurrency = (
    amount: number | string | null | undefined,
    {
        // locale = "en-US",
        locale = "bn-BD",
        // currency = "USD",
        currency = "BDT",
        compact = false,
        minimumFractionDigits,
        maximumFractionDigits,
    }: FormatCurrencyOptions = {}
): string => {
    if (amount === null || amount === undefined || amount === "") {
        return "";
    }

    const value = typeof amount === "string" ? Number(amount) : amount;

    if (Number.isNaN(value)) {
        return "";
    }

    const formatter = new Intl.NumberFormat(locale, {
        style: "currency",
        currency,
        notation: compact ? "compact" : "standard",
        compactDisplay: compact ? "short" : undefined,
        minimumFractionDigits,
        maximumFractionDigits,
    });

    return formatter.format(value);
};

// Format Number
export const formatNumber = (
    value: number | string | null | undefined,
    decimals: number = 0
): string => {
    if (value === null || value === undefined || value === "") {
        return "";
    }

    const num = typeof value === "string" ? Number(value) : value;

    if (Number.isNaN(num)) {
        return "";
    }

    return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    }).format(num);
};

// Format Date
export const formatDate = (
    date: string | Date | null | undefined,
    formatStr: string = "yyyy-MM-dd"
): string => {
    if (!date) return "";

    const parsedDate =
        typeof date === "string" ? parseISO(date) : date;

    if (!isValid(parsedDate)) {
        return "";
    }

    return format(parsedDate, formatStr);
};

// Format File Size
export const formatFileSize = (
    bytes: number | null | undefined,
    decimals: number = 2
): string => {
    if (bytes === null || bytes === undefined || Number.isNaN(bytes)) {
        return "";
    }

    if (bytes === 0) return "0 B";

    const k = 1024;
    const sizes = ["B", "KB", "MB", "GB", "TB", "PB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const value = bytes / Math.pow(k, i);

    return `${value.toFixed(decimals)} ${sizes[i]}`;
};

// Truncate String
export const truncateString = (
    str: string | null | undefined,
    maxLength: number
): string => {
    if (!str || maxLength <= 0) {
        return "";
    }

    if (str.length <= maxLength) {
        return str;
    }

    return str.slice(0, maxLength).trimEnd() + "…";
};

// Group-by Function
export const groupBy = <T, K extends PropertyKey>(
    items: T[],
    key: ((item: T) => K) | keyof T
): Record<K, T[]> => {
    const keyFn =
        typeof key === "function"
            ? key
            : (item: T) => item[key] as unknown as K;

    return items.reduce((acc, item) => {
        const k = keyFn(item);
        (acc[k] ??= []).push(item);
        return acc;
    }, {} as Record<K, T[]>);
};

//Slugify Function
export const slugify = (
    str: string | null | undefined
): string => {
    if (!str) return "";

    return str
        .toLowerCase()
        .trim()
        .normalize("NFD")                 // split accented characters
        .replace(/[\u0300-\u036f]/g, "") // remove accents
        .replace(/[^a-z0-9\s-]/g, "")    // remove special chars
        .replace(/\s+/g, "-")            // spaces with hyphen
        .replace(/-+/g, "-");            // collapse multiple hyphens
};

// Capitalize Function
export const capitalize = (
    str: string | null | undefined
): string => {
    if (!str) return "";

    return str.charAt(0).toUpperCase() + str.slice(1);
};

// Title-case Function
export const titleCase = (
    str: string | null | undefined
): string => {
    if (!str) return "";

    return str
        .toLowerCase()
        .split(" ")
        .filter(Boolean)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
};

// Deep Merge Function
export const deepMerge = <T extends Record<string, any>, U extends Record<string, any>>(
    obj1: T,
    obj2: U
): T & U => {
    const result: Record<string, any> = { ...obj1 };

    Object.keys(obj2).forEach((key) => {
        const val1 = obj1[key];
        const val2 = obj2[key];

        // If both values are plain objects, then merge recursively
        if (
            val1 &&
            val2 &&
            typeof val1 === "object" &&
            typeof val2 === "object" &&
            !Array.isArray(val1) &&
            !Array.isArray(val2)
        ) {
            result[key] = deepMerge(val1, val2);
        } else {
            // Otherwise, overwrite
            result[key] = val2;
        }
    });

    return result as T & U;
};

// Omit Function
export const omit = <T extends Record<string, any>, K extends keyof T>(
    obj: T,
    keys: K[]
): Omit<T, K> => {
    const result = { ...obj };
    keys.forEach(key => {
        delete result[key];
    });
    return result;
};

// Pick Function
export const pick = <T extends Record<string, any>, K extends keyof T>(
    obj: T,
    keys: K[]
): Pick<T, K> => {
    const result = {} as Pick<T, K>;
    keys.forEach(key => {
        if (key in obj) {
            result[key] = obj[key];
        }
    });
    return result;
};

// Flatten Array Function
export const flattenArray = <T>(arr: any[]): T[] => {
    if (!Array.isArray(arr)) return [];
    return arr.reduce<T[]>((acc, item) => {
        if (Array.isArray(item)) {
            acc.push(...flattenArray<T>(item));
        } else {
            acc.push(item);
        }
        return acc;
    }, []);
};

// Unique-by Function
export const uniqueBy = <T, K extends keyof T>(
    arr: T[],
    key: K
): T[] => {
    const seen = new Set<T[K]>();
    return arr.filter(item => {
        const k = item[key];
        if (seen.has(k)) {
            return false;
        }
        seen.add(k);
        return true;
    });
};

// Sort-by Function
export const sortBy = <T>(
    arr: T[],
    key: keyof T,
    direction: SortDirection = "asc"
): T[] => {
    return [...arr].sort((a, b) => {
        const valA = a[key];
        const valB = b[key];

        if (valA == null && valB != null) return direction === "asc" ? -1 : 1;
        if (valA != null && valB == null) return direction === "asc" ? 1 : -1;
        if (valA == null && valB == null) return 0;

        if (typeof valA === "number" && typeof valB === "number") {
            return direction === "asc" ? valA - valB : valB - valA;
        }

        const strA = String(valA).toLowerCase();
        const strB = String(valB).toLowerCase();

        if (strA < strB) return direction === "asc" ? -1 : 1;
        if (strA > strB) return direction === "asc" ? 1 : -1;
        return 0;
    });
};

// isEmpty Function
export const isEmpty = (value: any): boolean => {
    if (value === null || value === undefined) return true;

    if (typeof value === "string") return value.trim().length === 0;

    if (Array.isArray(value)) return value.length === 0;

    if (typeof value === "object") return Object.keys(value).length === 0;

    return false;
};

// isValidEmail Function
export const isValidEmail = (email: string | null | undefined): boolean => {
    if (!email) return false;

    const trimmed = email.trim();

    // Basic email regex (common standard)
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    return regex.test(trimmed);
};

// isValidURL Function
export const isValidURL = (url: string | null | undefined): boolean => {
    if (!url) return false;

    try {
        // The URL constructor throws if invalid
        new URL(url);
        return true;
    } catch {
        return false;
    }
};

export const safeReadText = async (res: any)=> {
    try {
        return await res.text();
    } catch {
        return "";
    }
}

export const getFilenameFromDisposition = (disposition: any)=> {
    if (!disposition) return null;

    // supports: filename="abc.xlsx" OR filename*=UTF-8''abc.xlsx
    const filenameStar = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(disposition);
    if (filenameStar?.[1]) return decodeURIComponent(filenameStar[1].trim().replace(/(^")|("$)/g, ""));

    const filename = /filename\s*=\s*"?([^"]+)"?/i.exec(disposition);
    if (filename?.[1]) return filename[1].trim();

    return null;
}

const ensureExtension = (filename: string, ext: string)=> {
    const cleanExt = ext.startsWith(".") ? ext : `.${ext}`;

    // Remove existing extension and add correct one
    return filename.replace(/\.[^/.]+$/, "") + cleanExt;
}

export const handleExportFile =async ({url, token, setLoading, setError,}: {
    url: string;
    token?: string;
    setLoading?: (v: boolean) => void;
    setError?: (v: string) => void;
})=> {
    setLoading?.(true);
    setError?.("");

    try {
        const res = await fetch(url, {
            method: "GET",
            headers: {
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
            },
        });

        if (!res.ok) {
            const msg = await safeReadText(res);
            throw new Error(msg || `Export failed (${res.status})`);
        }

        const contentType = res.headers.get("content-type") || "";
        const disposition = res.headers.get("content-disposition");

        let extension: "pdf" | "csv" | "xls" | "xlsx";
        let mimeType = contentType;

        // FILE TYPE DETECTION
        if (contentType.includes("application/pdf")) {
            extension = "pdf";
        } else if (
            contentType.includes("text/csv") ||
            contentType.includes("application/csv")
        ) {
            extension = "csv";
            mimeType = "text/csv;charset=utf-8";
        } else if (contentType.includes("application/vnd.ms-excel")) {
            extension = "xls";
        } else if (
            contentType.includes(
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            )
        ) {
            extension = "xlsx";
        } else {
            throw new Error(`Unsupported file type: ${contentType}`);
        }

        // FILENAME
        const baseFilename =
            getFilenameFromDisposition(disposition) ||
            `report-${new Date().toISOString().slice(0, 10)}`;

        const filename = ensureExtension(baseFilename, extension);

        // BINARY SAFE DOWNLOAD
        const buffer =
            extension === "pdf" ? await res.arrayBuffer() : await res.arrayBuffer();

        const blob = new Blob([buffer], { type: mimeType });

        const urlObject = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = urlObject;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(urlObject);

    }
    catch (e: any) {
        setError?.(e?.message || "Export failed");
    } finally {
        setLoading?.(false);
    }
}

export const maskNID = (nid:any)=> {
    if (!nid) return "";

    const str = String(nid).replace(/\s+/g, "");
    const length = str.length;

    if (length <= 4) return "*".repeat(length);

    const visible = str.slice(-4);
    return "*".repeat(length - 4) + visible;
}

export const formatPhone = (phone:any)=> {
    if (!phone) return "";

    // Remove all non-digits
    const digits = phone.replace(/\D/g, "");

    // Format as (XXX) XXX-XXXX or international +X XXX XXX XXXX
    if (digits.length === 10) {
        return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    } else if (digits.length === 11) {
        return `+${digits[0]} ${digits.slice(1, 4)} ${digits.slice(4, 7)} ${digits.slice(7)}`;
    } else {
        return phone; // fallback
    }
}

export const maskEmail = (email:any)=> {
    if (!email) return "";

    const [local, domain] = email.split("@");
    if (!domain) return email;

    let maskedLocal = local;
    if (local.length > 2) {
        maskedLocal = local[0] + "*".repeat(local.length - 2) + local[local.length - 1];
    } else if (local.length === 2) {
        maskedLocal = local[0] + "*";
    } else {
        maskedLocal = "*";
    }
    return `${maskedLocal}@${domain}`;
}


// maskEmail("john.doe@example.com");  // "j*******e@example.com"
// maskEmail("ab@domain.com");         // "a*@domain.com"
// maskEmail("x@domain.com");          // "*@domain.com"



export const handleDelete = async (params: deleteParams) => {
    const {
        id, endPoint, name, data = [], setData, token,
        toast, setUpdate, currentPage, setCurrentPage, router
    } = params
    const isArray = Array.isArray(id);
    const url = `${baseUrl?.url}${endPoint}`;

    const singlePayload: { ids: number[] } = { ids: [id] };

    const arrayPayload: { ids: number[] } | null = isArray ? {
        ids: id?.map((item: any) => (item?.id))
    } : null

    const options: RequestInit = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(isArray ? arrayPayload : singlePayload),
    };


    try {
        const res = await fetch(url, options);
        const responseData = await res.json();
        if (res.ok) {
            const itemsToDeleteCount = isArray ? id.length : 1;
            const willBeEmpty = data.length <= itemsToDeleteCount;

            if (currentPage && setCurrentPage && willBeEmpty) {
                if (willBeEmpty && currentPage > 1 && setCurrentPage) {
                    const newPage = currentPage - 1;
                    setCurrentPage(newPage);
                    router?.(`?page=${newPage}`, {replace: true});
                }
            }

            if (data?.length > 0 && setData) {
                const idsToRemove = isArray
                    ? id.map((item: any) => item.id)
                    : [id];

                const filteredData = data.filter((item: any) => !idsToRemove.includes(item?.id));
                setData(filteredData);
            }
            setUpdate?.((prev: boolean) => !prev);

            callToast(toast, true, `${name}${isArray ? 's' : ''} deleted successfully`);


        } else {
            callToast(toast, false, responseData?.message || 'Deletion failed');
        }
    } catch (error: any) {
        callToast(toast, false, error?.message || 'An error occurred');
    }
};


export const handleSingleURLDelete = async (params: any) => {
    const {
        id,  name, data = [], setData, token,
        toast, startEndpoint, finalEndpoint ='',currentPage, setCurrentPage, router, refetch,setDeleteLoading
    } = params

    try {
        setDeleteLoading(true)
        const res = await fetch(`${baseUrl?.url}${startEndpoint}${id}${finalEndpoint !== '' ? finalEndpoint : ''}`, {
            method: "DELETE",
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        if (res.ok) {
            if (data.length === 1 && currentPage && setCurrentPage) {
                const newPage = Math.max(currentPage - 1, 1);
                setCurrentPage(newPage);
                if (router) {
                    router(`?page=${newPage}`, { replace: true });
                }
            }
            if (data?.length > 0 && setData) {
                const filteredData =  data.filter((item: any) => item?.id !== id);
                setData(filteredData);
            }
            if(refetch){
                refetch()
            }
            callToast(toast, true, `${name} deleted successfully`);
        } else {
            const responseData = await res.json();
            callToast(toast, false, responseData?.errors[0]);
        }
    } catch (error: any) {
        callToast(toast, false, error?.message);
    }finally {
        setDeleteLoading(false)
    }
};

